export const courseConstants = {
  FETCH_START: "FETCH_START",
  FETCH_END: "FETCH_END",
  SET_COURSES: "SET_COURSES",
  MY_COURSE_LIST: "MY_COURSE_LIST",
  MY_COURSE_LIST_FAILURE: "MY_COURSE_LIST_FAILURE",
  SEARCH_COURSES: "SEARCH_COURSES",
  SET_PURCHASED_COURSES: "SET_PURCHASED_COURSES",
  SET_VIEW_AWARDS: "SET_VIEW_AWARDS",
  RESET_COURSELIST: "RESET_COURSELIST",
  RESET_MY_COURSELIST: "RESET_MY_COURSELIST",
  SET_RESET_PURCHASED_COURSES: "SET_RESET_PURCHASED_COURSES",
};
